<template>
	<div class="exhibit-wrap">
		<el-breadcrumb separator="/" class="path">
			<el-breadcrumb-item :to="{ path: '/' }" class="path-home"><i class="n el-icon-s-home"></i>首页</el-breadcrumb-item>
			<el-breadcrumb-item class="path-news">行业动态</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="news" v-loading="loading">
			<div class="content">
				<div class="left-column">
					<div class="first" v-if="flagList[0]">
						<router-link :to="`/exhibit-detail-${flagList[0].id}`" target="_blank">
							<h2>{{flagList[0].title || ''}}</h2>
							<desc-text class="text" :text="flagList[0].introduce" :textStyle="{WebkitLineClamp:3}"></desc-text>
						</router-link>
					</div>
					<div class="list">
						<list3 :list="flagList.slice(1,11)"></list3>
					</div>
				</div>
				<div class="right-column">
					<div class="first-image" v-if="flagList[0]">
						<router-link :to="`/exhibit-detail-${flagList[0].id}`" target="_blank">
							<el-image :src="$img(flagList[0].thumb)" class="image" fit="cover" @click="$router.pushToTab(flagList[0].thumb)" />
							<h2>{{flagList[0].title || ''}}</h2>
						</router-link>
					</div>
					<div class="list-box">
						<list4 :list="flagList.slice(1,4)"></list4>
					</div>
				</div>
			</div>
			<!-- 广告位 -->
			<div class="ad ad-1"  v-if="ad1">
				<el-image :src="$img(ad1.adv_image)" fit="cover" @click="$router.pushToTab(ad1.adv_url.url)" />
			</div>
			<div class="block1">
				<block-style1 :catId="19" title="国内展会"></block-style1>
			</div>
			<!-- 广告位 -->
			<div class="ad ad-2"  v-if="ad2">
				<el-image :src="$img(ad1.adv_image)" fit="cover" @click="$router.pushToTab(ad1.adv_url.url)" />
			</div>
			<div class="block2">
				<block-style1 :catId="20" title="国际展会"></block-style1>
			</div>
		</div>
	</div>
</template>

<script>
	import {exhibitList,exhibitCat} from "@/api/cms/exhibit"
	import { adList } from "@/api/website"
	import { mapGetters } from "vuex"
	// import SubTitle from "@/components/SubTitle"
	import DescText from "@/components/DescText"
	import sidebar from "./components/sidebar"
	import list3 from "./components/list3"
	import list4 from "./components/list4"
	import blockStyle1 from "./components/block-style1"
	
	
	export default {
		name: "news",
		components: {
			// SubTitle,
			DescText,
			sidebar,
			list3,
			list4,
			blockStyle1
		},
		data: () => {
			return {
				loading: true,
				flagList:[],
				ad1:null,
				ad2:null,
			};
		},
		created() {
			this.getInfo();
		},
		computed: {
		    ...mapGetters(["defaultGoodsImage"])
		},
		methods: {
			getInfo() {
				// this.loading = false;
				
				this.getFlagList()
				this.getAd();
			},
			getFlagList(){
				exhibitList({
					// flag:1,
					page_size:20,
					order:'flag desc'
				}).then(res=>{
					if (res.code == 0 && res.data) {
						this.flagList = res.data.list;
					}
					this.loading = false;
				}).catch(err => {
					this.loading = false;
					this.$message.error(err.message);
				});
			},
			getAd(){
				adList({ keyword: "PC_EXHIBIT_INDEX" })
				.then(res => {
					this.ad1 = res.data.adv_list[0]
					this.ad2 = res.data.adv_list[1]
				})
				.catch(err => {
				})
			}
		}
	};
</script>
<style lang="scss" scoped>
.exhibit-wrap {
	background: #ffffff;
	.path {
		padding: 15px 0;
	}
}

.news {
	// display: flex;
	padding-bottom: 20px;
}

.news .content{
	display: flex;
	flex-flow: wrap;
	width: 1210px;
	margin-bottom: 20px;
	.left-column{
		width: 610px;
		// flex: 1;
		display: block;
		.first{
			margin-bottom: 15px;
			h2{
				overflow: hidden;
				text-overflow:ellipsis;
				white-space: nowrap;
				line-height: 50px;
			}
			.text{
				height: 75px;
			}
		}
		.sub-list{
			.list{
				display: flex;
				.item:first-child{
					margin-left: 0;
				}
				.item{
					width: 33.333%;
					margin-left: 30px;
					// padding-bottom: 10px;
					border: 1px solid #efefef;
					margin-bottom: 20px;
					overflow:hidden;
					.image{
						width: 100%;
						height: 200px;
					}
					p{
						padding: 5px 10px;
						overflow: hidden;
						text-overflow:ellipsis;
						white-space: nowrap;
					}
					// padding: 15px;
				}
			}
		}
	}
	.right-column{
		// width: 260px;
		flex: 1;
		padding-left: 20px;
		overflow: hidden;
		.first-image{
			position: relative;
			box-sizing: border-box;
			.image{
				width: 100%;
				height: 280px;
			}
			h2{
				position: absolute;
				z-index: 9;
				// top: 0;
				left: 0;
				bottom: 0;
				background-color: rgb(0, 0, 0,0.6);
				color: #fff;
				font-size: 14px;
				text-align: center;
				overflow: hidden;
				text-overflow:ellipsis;
				white-space: nowrap;
				// padding:  10px 0 ;
				line-height: 30px;
				width: 100%;
			}
		}
		.list-box{
			margin-top: 15px;
		}
	}
}
.news .ad{
	display: block;
}
</style>
